/**
 * Implementation of IFloodgateTelemetryLogger for Web SDK
 */
import * as Logging from "../Logging/Logging";
export default class IFloodgateTelemetryLogger {
  /**
   * Log that a survey's trigger was met.
   * @param campaignId Id of the campaign the survey belongs to.
   * @param surveyId Id of the survey.
   * @param surveyType Type of the survey.
   * @param surveyActivityInfo The survey's activities' information such as names, counts, isAggregate and if the list is ordered.
   * @param additionalSurveyInfo additional survey info in a stringified json object:
   * 		- surveyLauncherType: LauncherType of the survey.
   * 		- channelType: The channel type of the survey's campaign.
   * 		- surveyPercentageNumerator: Percentage numerator of the survey's Campaign.
   * 		- surveyPercentageDenominator: Percentage denominator of the survey's Campaign.
   * 		- surveyNominationPeriodNumber: The Nomination Period of the survey's Campaign in seconds, -1 if not applicable.
   * 		- surveyCooldownPeriodNumber: The Cooldown Period of the survey's Campaign in seconds, -1 if not applicable.
   * 		- allCandidateCampaignDefinitionIDs: The list of campaign definition IDs that have corresponding surveys which are candidates.
   * 		- allCampaignDefinitionIDs: The list of all campaign definition IDs.
   */
  log_TriggerMet(campaignId, surveyId, surveyType, surveyActivityInfo, additionalSurveyInfo) {
    Logging.getLogger().logEvent(Logging.EventIds.SURVEY_FLOODGATE_TRIGGERMET, 1 /* Critical */, {
      CampaignId: campaignId,
      SurveyId: surveyId,
      SurveyType: surveyType,
      SurveyActivityInfo: surveyActivityInfo,
      AdditionalSurveyInfo: additionalSurveyInfo
    });
  }
  /**
   * Log that a user was selected(nominated) for a survey if it's not sampled
   * @param campaignId Id of the campaign the survey belongs to.
   * @param surveyId Id of the survey.
   * @param surveyType Type of the survey.
   * @param additionalSurveyInfo additional survey info in a stringified json object:
   * 		- surveyLauncherType LauncherType of the survey.
   * 		- channelType The channel type of the survey's campaign.
   * 		- surveyPercentageNumerator Percentage numerator of the survey's Campaign.
   * 		- surveyPercentageDenominator Percentage denominator of the survey's Campaign.
   * 		- surveyNominationPeriodNumber The Nomination Period of the survey's Campaign in seconds, -1 if not applicable.
   * 		- surveyCooldownPeriodNumber The Cooldown Period of the survey's Campaign in seconds, -1 if not applicable.
   * 		- allCandidateCampaignDefinitionIDs: The list of campaign definition IDs that have corresponding surveys which are candidates.
   * 		- allCampaignDefinitionIDs: The list of all campaign definition IDs.
   */
  log_UserSelected(campaignId, surveyId, surveyType, additionalSurveyInfo) {
    Logging.getLogger().logEvent(Logging.EventIds.SURVEY_FLOODGATE_USERSELECTED, 1 /* Critical */, {
      CampaignId: campaignId,
      SurveyId: surveyId,
      SurveyType: surveyType,
      AdditionalSurveyInfo: additionalSurveyInfo
    });
  }
  /**
   * Log that campaign definitions failed to load.
   * @param errorMessage error message
   */
  log_CampaignLoad_Failed(errorMessage) {
    Logging.getLogger().logEvent(Logging.EventIds.SURVEY_FLOODGATE_CAMPAIGNLOAD_FAILED, 2 /* Error */, {
      ErrorMessage: errorMessage
    });
  }
  /**
   * Log an event with error message
   * @param eventId event id
   * @param errorMessage error message
   */
  log_Error(eventId, errorMessage) {
    const event = {
      name: eventId
    };
    Logging.getLogger().logEvent(event, 2 /* Error */, {
      ErrorMessage: errorMessage
    });
  }
  /**
   * Log an event with properties
   * @param eventId event id
   * @param properties telemetry event properties
   */
  log_Event(eventId, properties) {
    const event = {
      name: eventId
    };
    Logging.getLogger().logEvent(event, 1 /* Critical */, properties);
  }
  /**
   * Log message locally
   * @param message message
   * @param data message data
   */
  log_LocalError(message) {
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }
    this.log_Local(2 /* Error */, message, data);
  }
  log_Local(logSeverity, message) {
    for (var _len2 = arguments.length, others = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      others[_key2 - 2] = arguments[_key2];
    }
    Logging.getLogger().logLocal(logSeverity, others);
  }
}